var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"navigation"},[_c('div',{staticClass:"logo-wrapper"},[_c('Logo',{attrs:{"brand":"assets/images/logos/culto.svg","title":"Culto","href":"http://culto.latercera.com"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }